import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PalletService } from "src/services/pallets";
import { queryKeys } from "src/constants";

const useReopenPallet = (palletService: PalletService, onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  const { mutateAsync: reopenPallet, isPending: isReopening } = useMutation({
    mutationFn: (palletId: string) => palletService.reopenPallet(palletId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.buildingPallets() });
      queryClient.invalidateQueries({ queryKey: queryKeys.completePallets() });
      queryClient.invalidateQueries({ queryKey: queryKeys.paginatedPallets() });
      queryClient.invalidateQueries({ queryKey: queryKeys.palletStats() });
      queryClient.invalidateQueries({ queryKey: queryKeys.palletLocations() });
      onSuccess?.();
    }
  });

  return { reopenPallet, isReopening };
};

export { useReopenPallet };
